import React from 'react';
import './CvList.css';

function CvList({ cvs, onDownload, onDelete }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  };

  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return '📕';
      case 'doc':
      case 'docx':
        return '📘';
      default:
        return '📄';
    }
  };

  if (cvs.length === 0) {
    return (
      <div className="cv-list-empty">
        <div className="empty-icon">📋</div>
        <h3>No CVs uploaded yet</h3>
        <p>Upload your first CV using the form above</p>
      </div>
    );
  }

  return (
    <div className="cv-list">
      <h2>Your CVs ({cvs.length})</h2>

      <div className="cv-grid">
        {cvs.map((cv) => (
          <div key={cv.id} className="cv-card">
            <div className="cv-card-header">
              <span className="file-icon">{getFileIcon(cv.fileName)}</span>
              <div className="cv-info">
                <h3 className="cv-filename" title={cv.fileName}>
                  {cv.fileName}
                </h3>
                <p className="cv-size">{formatFileSize(cv.fileSizeBytes)}</p>
              </div>
            </div>

            <div className="cv-card-body">
              <div className="cv-meta">
                <div className="meta-item">
                  <span className="meta-label">Uploaded:</span>
                  <span className="meta-value">{formatDate(cv.uploadedAt)}</span>
                </div>
                {cv.updatedAt && (
                  <div className="meta-item">
                    <span className="meta-label">Updated:</span>
                    <span className="meta-value">{formatDate(cv.updatedAt)}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="cv-card-actions">
              <button
                onClick={() => onDownload(cv)}
                className="btn btn-outline"
                title="Download CV"
              >
                <span className="btn-icon">⬇️</span>
                Download
              </button>
              <button
                onClick={() => onDelete(cv.id)}
                className="btn btn-danger"
                title="Delete CV"
              >
                <span className="btn-icon">🗑️</span>
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CvList;
